import React from 'react';
import styles from '../styles/spinner.scss';
const Spinner = ({ text }) => {
    // const containerStyles = `${styles.container} ${styles.light} ${styles.rotate}`;
    // const dotStyles = `${styles.dot}`;
    return (React.createElement("div", { className: styles.wrapper }, text ? React.createElement("span", { className: styles.text }, text) : ''));
};
export default Spinner;
